import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'sanitizeHtml',
    standalone: false
})

export class sanitizeHtmlPipe implements PipeTransform  {

  constructor(private _sanitizer:DomSanitizer) { }

  transform(value: string): string {
    if (value == null || value === '') {
      return '';
    }
    return this._sanitizer.sanitize(SecurityContext.HTML, value) ?? '';
  }
}

@Pipe({
    name: 'moblieOtpPipe',
    standalone: false
})

export class moblieOtpPipe implements PipeTransform  {

  constructor() { }

  transform(value:string) {
    let result = ''
    for (let i = value.length-1; i > value.length-4; i--) {
      let str = value.charAt(i)
      result = str+result
    }
    result = 'XXX-XXXX-'+result
    return result;
  }
}

@Pipe({
    name: 'formatMoneyPipe',
    standalone: false
})

export class formatMoneyPipe implements PipeTransform  {

  constructor() { }

  transform(value:string | number) {
    let decimalCount:any = 2
    let decimal:any = "."
    let thousands:any = ","
    let result:any = ''
    let amountValue = parseFloat(('' + value).replace(/,/g, ''))
    let [n, d] = (''+amountValue).split(".")
    let amount:any = +n
    if(+d>0){
      amount = amount+1
    }

    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
      const negativeSign = amount < 0 ? "-" : "";
      let i:any = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j:any = (i.length > 3) ? i.length % 3 : 0;
      let result:any = negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
      result = result.replace('.00', '')
      return result
    } catch (e) {
      console.log(e)
      return result
    }
    
  }
}

@Pipe({
    name: 'formatMoneyDiscountPipe',
    standalone: false
})

export class formatMoneyDiscountPipe implements PipeTransform  {

  constructor() { }

  transform(value:string) {
    let decimalCount:any = 2
    let decimal:any = "."
    let thousands:any = ","
    let result:any = ''
    let amountValue = parseFloat(('' + value).replace(/,/g, ''))
    let [n, d] = (''+amountValue).split(".")
    let amount:any = +n
    //ไม่ปัดเศษขึ้น
    // if(+d>0){
    //   amount = amount+1
    // }

    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
      const negativeSign = amount < 0 ? "-" : "";
      let i:any = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j:any = (i.length > 3) ? i.length % 3 : 0;
      let result:any = negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
      result = result.replace('.00', '')
      return result
    } catch (e) {
      console.log(e)
      return result
    }
    
  }
}